/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum APPOINTMENT_STATE {
  AWAITING_RESCHEDULE = "AWAITING_RESCHEDULE",
  AWAITING_TRANSFER = "AWAITING_TRANSFER",
  NEW = "NEW",
  RESCHEDULE = "RESCHEDULE",
  TRANSFER = "TRANSFER",
  TRANSFERRED = "TRANSFERRED",
}

export interface GetCowinBeneficiaryInput {
  mobileNumber: string;
}

export interface CowinLoginVerifyInput {
  operationType: OperationType;
  mobileNumber: string;
  otp?: string | null;
  txnId?: string | null;
}
export interface fileUploadType {
  fileName?: string | null;
  mimeType?: string | null;
  content?: string | null;
}
export interface AddClinicalDocumentInput {
  id?: string | null;
  createdDate?: string | null;
  lastmodifieddate?: string | null;
  mobileNumber?: string | null;
  uhid?: string | null;
  uploadedVia?: string | null;
  documentName?: string | null;
  fileType?: string | null;
  fileInfoList?: (fileUploadType | null)[] | null;
  source?: string | null;
  sourcePlatform?: string;
}

export enum PS_ORDER_STATUS {
  AUTHENTICATION_FAILED = "AUTHENTICATION_FAILED",
  AUTHORIZATION_FAILED = "AUTHORIZATION_FAILED",
  AUTHORIZING = "AUTHORIZING",
  AUTO_FAILED = "AUTO_FAILED",
  AUTO_FAILED_REFUNDED = "AUTO_FAILED_REFUNDED",
  AUTO_REFUNDED = "AUTO_REFUNDED",
  CAPTURE_FAILED = "CAPTURE_FAILED",
  CAPTURE_INITIATED = "CAPTURE_INITIATED",
  CHARGED = "CHARGED",
  COD_COMPLETE = "COD_COMPLETE",
  CREATED = "CREATED",
  INITIATION_FAILED = "INITIATION_FAILED",
  JUSPAY_DECLINED = "JUSPAY_DECLINED",
  NEW = "NEW",
  PENDING_VBV = "PENDING_VBV",
  STARTED = "STARTED",
  VOIDED = "VOIDED",
  VOID_FAILED = "VOID_FAILED",
  VOID_INITIATED = "VOID_INITIATED",
}

export enum PS_PAYMENT_STATUS {
  AUTO_FAILED = "AUTO_FAILED",
  AUTO_FAILED_REFUNDED = "AUTO_FAILED_REFUNDED",
  AUTO_REFUNDED = "AUTO_REFUNDED",
  COD_COMPLETE = "COD_COMPLETE",
  INITIATION_FAILED = "INITIATION_FAILED",
  PAYMENT_NOT_INITIATED = "PAYMENT_NOT_INITIATED",
  PENDING = "PENDING",
  TXN_FAILURE = "TXN_FAILURE",
  TXN_SUCCESS = "TXN_SUCCESS",
}

export enum REFUND_STATUSES {
  FAILURE = "FAILURE",
  MANUAL_REVIEW = "MANUAL_REVIEW",
  PENDING = "PENDING",
  REFUND_INITIATION_FAILED = "REFUND_INITIATION_FAILED",
  REFUND_REQUEST_NOT_SENT = "REFUND_REQUEST_NOT_SENT",
  RETRIED = "RETRIED",
  SUCCESS = "SUCCESS",
}
export enum VERTICALS {
  consult = "consult",
  diagnostics = "diagnostics",
  pharma = "pharma",
  subscription = "subscription",
  vaccination = "vaccination",
}

export enum WALLETS {
  AIRTELMONEY = "AIRTELMONEY",
  AMAZONPAY = "AMAZONPAY",
  FREECHARGE = "FREECHARGE",
  GOOGLEPAY = "GOOGLEPAY",
  JANACASH = "JANACASH",
  JIOMONEY = "JIOMONEY",
  LAZYPAY = "LAZYPAY",
  MOBIKWIK = "MOBIKWIK",
  OLAMONEY = "OLAMONEY",
  OXIGEN = "OXIGEN",
  PAYPAL = "PAYPAL",
  PAYTM = "PAYTM",
  PAYUMONEY = "PAYUMONEY",
  PAYZAPP = "PAYZAPP",
  PHONEPE = "PHONEPE",
  SIMPL = "SIMPL",
}

export interface DeleteMultipleHealthRecordFilesInput {
  fileIndexArray?: (number | null)[] | null;
  patientId: string;
  recordType: MedicalRecordType;
  recordId?: string | null;
}

export interface AddPatientVaccinationRecordInput {
  id?: string | null;
  patientId: string;
  recordType: MedicalRecordType;
  vaccineName: string;
  dateOfImmunization?: any | null;
  registrationId?: string;
  vaccine_location?: string;
  batchno?: string;
  immunizationName: string;
}

export enum OperationType {
  GENERATE_OTP = "GENERATE_OTP",
  VERIFY_OTP = "VERIFY_OTP",
}

export interface getUhidData {
  firstName: string;
}

export interface getUhidVariables {
  uhid: string;
}

export enum REPORT_TYPE {
  LABTEST = "LabTest",
  PRESCRIPTION = "Prescription",
  BILL = "Bill",
  HOSPITALIZATION = "Hospitalization",
}

export interface FamilyHistoryFilesProperties {
  fileName?: string | null;
  mimeType?: string | null;
  content?: string | null;
}

export interface FamilyHistoryParameters {
  patientId: string;
  diseaseName?: string | null;
  id?: string | null;
  familyMember?: Relation | null;
  notes?: string | null;
  age?: number | null;
  recordDate?: any | null;
  attachmentList?: (FamilyHistoryFilesProperties | null)[] | null;
}

export enum WALLET_TXN_TYPE {
  PUSH_PAY = "PUSH_PAY",
}

export enum PAYMENT_METHODS_JUSPAY {
  CARD = "CARD",
  COD = "COD",
  CONSUMER_FINANCE = "CONSUMER_FINANCE",
  CRED = "CRED",
  HEALTH_CREDITS = "HEALTH_CREDITS",
  HEALTH_CREDITS_VOUCHER = "HEALTH_CREDITS_VOUCHER",
  NB = "NB",
  PAY_LATER = "PAY_LATER",
  REWARD = "REWARD",
  UPI = "UPI",
  VOUCHER = "VOUCHER",
  WALLET = "WALLET",
}

export enum APPOINTMENT_TYPE {
  BOTH = "BOTH",
  ONLINE = "ONLINE",
  PHYSICAL = "PHYSICAL",
}

export enum AllergySeverity {
  LIFE_THREATENING = "LIFE_THREATENING",
  MILD = "MILD",
  NOT_KNOWN = "NOT_KNOWN",
  SEVERE = "SEVERE",
}

export enum AppointmentType {
  BOTH = "BOTH",
  ONLINE = "ONLINE",
  PHYSICAL = "PHYSICAL",
}

/**
 * Indicates what type of attribute
 */
export enum AttributeType {
  LIMITED = "LIMITED",
  RECURRING = "RECURRING",
  UNLIMTED = "UNLIMTED",
}

export enum BOOKINGSOURCE {
  ADMIN_DASHBOARD = "ADMIN_DASHBOARD",
  BOOKING_TOOL = "BOOKING_TOOL",
  COMS_SERVICE = "COMS_SERVICE",
  DOCTOR_MOBILE = "DOCTOR_MOBILE",
  DOCTOR_WEB = "DOCTOR_WEB",
  MOBILE = "MOBILE",
  PAPERPLANE_API = "PAPERPLANE_API",
  PHARMA_SERVICE = "PHARMA_SERVICE",
  WEB = "WEB",
}

export enum docOnCallType {
  CIRCLE = "CIRCLE",
  COVID_VACCINATION_QUERY = "COVID_VACCINATION_QUERY",
  HDFC = "HDFC",
}

export enum BOOKING_SOURCE {
  MFINE = "MFINE",
  MOBILE = "MOBILE",
  ORDER_PUNCHING_TOOL = "ORDER_PUNCHING_TOOL",
  WEB = "WEB",
}

export enum BannerDisplayType {
  banner = "banner",
  card = "card",
}

export enum BannerVisibilityTypes {
  LOGGED_IN = "LOGGED_IN",
  LOGGED_OUT = "LOGGED_OUT",
  SUBSCRIBED = "SUBSCRIBED",
  UNSUBSCRIBED = "UNSUBSCRIBED",
}

export enum BloodGroups {
  ABNegative = "ABNegative",
  ABPositive = "ABPositive",
  ANegative = "ANegative",
  APositive = "APositive",
  BNegative = "BNegative",
  BPositive = "BPositive",
  ONegative = "ONegative",
  OPositive = "OPositive",
}

export enum CODCity {
  CHENNAI = "CHENNAI",
}

export enum CONSULTS_RX_SEARCH_FILTER {
  ONLINE = "ONLINE",
  PHYSICAL = "PHYSICAL",
  PRESCRIPTION = "PRESCRIPTION",
}

export enum ConsultMode {
  BOTH = "BOTH",
  ONLINE = "ONLINE",
  PHYSICAL = "PHYSICAL",
}

export enum ConsultType {
  FIXED = "FIXED",
  PREFERRED = "PREFERRED",
}

export enum CouponCategoryApplicable {
  FMCG = "FMCG",
  PHARMA = "PHARMA",
  PHARMA_FMCG = "PHARMA_FMCG",
  PL = "PL",
}

export enum DEVICETYPE {
  ANDROID = "ANDROID",
  DESKTOP = "DESKTOP",
  IOS = "IOS",
}

export enum DEVICE_TYPE {
  ANDROID = "ANDROID",
  DESKTOP = "DESKTOP",
  IOS = "IOS",
  MWEB = "MWEB",
  WEB = "WEB",
}

export enum DIAGNOSTICS_TYPE {
  PACKAGE = "PACKAGE",
  TEST = "TEST",
}

export enum DIAGNOSTIC_ORDER_PAYMENT_TYPE {
  COD = "COD",
  ONLINE_PAYMENT = "ONLINE_PAYMENT",
}

export enum DOCTOR_ONLINE_STATUS {
  AWAY = "AWAY",
  ONLINE = "ONLINE",
}

export enum DiscountType {
  FLATPRICE = "FLATPRICE",
  PERCENT = "PERCENT",
  PRICEOFF = "PRICEOFF",
}

export enum DoctorType {
  APOLLO = "APOLLO",
  APOLLO_HOMECARE = "APOLLO_HOMECARE",
  ATHS_PHARMA = "ATHS_PHARMA",
  CLINIC = "CLINIC",
  CLINIC_247 = "CLINIC_247",
  CLINIC_247_FRANCHISE = "CLINIC_247_FRANCHISE",
  CRADLE = "CRADLE",
  DIGITAL_THERAPEUTICS = "DIGITAL_THERAPEUTICS",
  DOCTOR_CONNECT = "DOCTOR_CONNECT",
  EXCLUSIVE_PARTNER = "EXCLUSIVE_PARTNER",
  FERTILITY = "FERTILITY",
  JUNIOR = "JUNIOR",
  OS_PHARMA = "OS_PHARMA",
  PAYROLL = "PAYROLL",
  SPECTRA = "SPECTRA",
  STAR_APOLLO = "STAR_APOLLO",
  SUGAR = "SUGAR",
  WHITE_DENTAL = "WHITE_DENTAL",
}

export enum ITEM_TYPE {
  LABTEST = "LABTEST",
  PACKAGE = "PACKAGE",
}

export enum FEEDBACKTYPE {
  CONSULT = "CONSULT",
  DIAGNOSTICS = "DIAGNOSTICS",
  PHARMACY = "PHARMACY",
}

export enum Gender {
  FEMALE = "FEMALE",
  MALE = "MALE",
  OTHER = "OTHER",
}

export enum HDFC_CUSTOMER {
  NOT_HDFC_CUSTOMER = "NOT_HDFC_CUSTOMER",
  OTP_GENERATED = "OTP_GENERATED",
  OTP_NOT_GENERATED = "OTP_NOT_GENERATED",
}

export enum HealthRestrictionNature {
  Dietary = "Dietary",
  OTHER = "OTHER",
  Physical = "Physical",
}

export enum LOGIN_TYPE {
  DOCTOR = "DOCTOR",
  PATIENT = "PATIENT",
  EMAIL = "EMAIL",
}

export enum MEDICINE_CONSUMPTION_DURATION {
  DAYS = "DAYS",
  MONTHS = "MONTHS",
  TILL_NEXT_REVIEW = "TILL_NEXT_REVIEW",
  WEEKS = "WEEKS",
}

export enum MEDICINE_DELIVERY_TYPE {
  HOME_DELIVERY = "HOME_DELIVERY",
  STORE_PICKUP = "STORE_PICKUP",
}

export enum MEDICINE_FORM_TYPES {
  GEL_LOTION_OINTMENT = "GEL_LOTION_OINTMENT",
  OTHERS = "OTHERS",
}

export enum MEDICINE_FREQUENCY {
  ALTERNATE_DAY = "ALTERNATE_DAY",
  AS_NEEDED = "AS_NEEDED",
  EVERY_FOUR_HOURS = "EVERY_FOUR_HOURS",
  EVERY_HOUR = "EVERY_HOUR",
  EVERY_TWO_HOURS = "EVERY_TWO_HOURS",
  FIVE_TIMES_A_DAY = "FIVE_TIMES_A_DAY",
  FOUR_TIMES_A_DAY = "FOUR_TIMES_A_DAY",
  ONCE_A_DAY = "ONCE_A_DAY",
  ONCE_A_MONTH = "ONCE_A_MONTH",
  ONCE_A_WEEK = "ONCE_A_WEEK",
  ONCE_IN_15_DAYS = "ONCE_IN_15_DAYS",
  STAT = "STAT",
  THREE_TIMES_A_WEEK = "THREE_TIMES_A_WEEK",
  THRICE_A_DAY = "THRICE_A_DAY",
  TWICE_A_DAY = "TWICE_A_DAY",
  TWICE_A_WEEK = "TWICE_A_WEEK",
}

export enum MEDICINE_ORDER_PAYMENT_TYPE {
  CASHLESS = "CASHLESS",
  COD = "COD",
  NO_PAYMENT = "NO_PAYMENT",
}

export enum MEDICINE_ORDER_STATUS {
  CANCELLED = "CANCELLED",
  CANCEL_REQUEST = "CANCEL_REQUEST",
  DELIVERED = "DELIVERED",
  ITEMS_RETURNED = "ITEMS_RETURNED",
  ON_HOLD = "ON_HOLD",
  ORDER_BILLED = "ORDER_BILLED",
  ORDER_CONFIRMED = "ORDER_CONFIRMED",
  ORDER_FAILED = "ORDER_FAILED",
  ORDER_INITIATED = "ORDER_INITIATED",
  ORDER_PLACED = "ORDER_PLACED",
  ORDER_VERIFIED = "ORDER_VERIFIED",
  OUT_FOR_DELIVERY = "OUT_FOR_DELIVERY",
  PAYMENT_ABORTED = "PAYMENT_ABORTED",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  PAYMENT_PENDING = "PAYMENT_PENDING",
  PAYMENT_SUCCESS = "PAYMENT_SUCCESS",
  PICKEDUP = "PICKEDUP",
  PRESCRIPTION_CART_READY = "PRESCRIPTION_CART_READY",
  PRESCRIPTION_UPLOADED = "PRESCRIPTION_UPLOADED",
  PURCHASED_IN_STORE = "PURCHASED_IN_STORE",
  QUOTE = "QUOTE",
  READY_AT_STORE = "READY_AT_STORE",
  READY_FOR_VERIFICATION = "READY_FOR_VERIFICATION",
  READY_TO_SHIP = "READY_TO_SHIP",
  RETURN_ACCEPTED = "RETURN_ACCEPTED",
  RETURN_INITIATED = "RETURN_INITIATED",
  RETURN_PENDING = "RETURN_PENDING",
  RETURN_PICKUP = "RETURN_PICKUP",
  RETURN_REQUESTED = "RETURN_REQUESTED",
  RETURN_RTO = "RETURN_RTO",
  RETURN_TO_ORIGIN = "RETURN_TO_ORIGIN",
  RVP_ASSIGNED = "RVP_ASSIGNED",
  SHIPPED = "SHIPPED",
  VERIFICATION_DONE = "VERIFICATION_DONE",
}

export enum MEDICINE_ORDER_TYPE {
  CART_ORDER = "CART_ORDER",
  UPLOAD_PRESCRIPTION = "UPLOAD_PRESCRIPTION",
}

export enum MEDICINE_TIMINGS {
  AS_NEEDED = "AS_NEEDED",
  EVENING = "EVENING",
  MORNING = "MORNING",
  NIGHT = "NIGHT",
  NOON = "NOON",
  NOT_SPECIFIC = "NOT_SPECIFIC",
}

export enum MEDICINE_TO_BE_TAKEN {
  AFTER_FOOD = "AFTER_FOOD",
  BEFORE_FOOD = "BEFORE_FOOD",
}

export enum MEDICINE_UNIT {
  AS_PRESCRIBED = "AS_PRESCRIBED",
  BOTTLE = "BOTTLE",
  CAPSULE = "CAPSULE",
  CREAM = "CREAM",
  DROP = "DROP",
  DROPS = "DROPS",
  GEL = "GEL",
  GM = "GM",
  INJECTION = "INJECTION",
  INTERNATIONAL_UNIT = "INTERNATIONAL_UNIT",
  LOTION = "LOTION",
  MG = "MG",
  ML = "ML",
  NA = "NA",
  OINTMENT = "OINTMENT",
  OTHERS = "OTHERS",
  PATCH = "PATCH",
  POWDER = "POWDER",
  PUFF = "PUFF",
  ROTACAPS = "ROTACAPS",
  SACHET = "SACHET",
  SOAP = "SOAP",
  SOLUTION = "SOLUTION",
  SPRAY = "SPRAY",
  SUSPENSION = "SUSPENSION",
  SYRUP = "SYRUP",
  TABLET = "TABLET",
  TEASPOON = "TEASPOON",
  UNIT = "UNIT",
}

export enum MedicalConditionIllnessTypes {
  Acute = "Acute",
  Chronic = "Chronic",
  Intermittent = "Intermittent",
  Recurring = "Recurring",
}
export interface VerifyVPA {
  is_pharma?: boolean | null;
  merchant_id?: string | null;
  save_vpa?: boolean | null;
  vpa: string;
}
export interface UPICollect {
  order_id: string;
  payment_method_type: PAYMENT_METHODS_JUSPAY;
  payment_method: UPI_COLLECT_METHOD;
  txn_type: UPI_TXN_TYPE;
  upi_vpa: string;
  redirect_after_payment: boolean;
  format?: string | null;
}

export enum UPI_COLLECT_METHOD {
  UPI = "UPI",
}

export enum UPI_TXN_TYPE {
  UPI_COLLECT = "UPI_COLLECT",
}

export enum MedicalRecordType {
  ALLERGY = "ALLERGY",
  CONSULTATION = "CONSULTATION",
  EHR = "EHR",
  FAMILY_HISTORY = "FAMILY_HISTORY",
  HEALTHCHECK = "HEALTHCHECK",
  HEALTHRESTRICTION = "HEALTHRESTRICTION",
  HOSPITALIZATION = "HOSPITALIZATION",
  IMMUNIZATION = "IMMUNIZATION",
  MEDICALBILL = "MEDICALBILL",
  MEDICALCONDITION = "MEDICALCONDITION",
  MEDICALINSURANCE = "MEDICALINSURANCE",
  MEDICATION = "MEDICATION",
  OPERATIVE_REPORT = "OPERATIVE_REPORT",
  PATHOLOGY_REPORT = "PATHOLOGY_REPORT",
  PHYSICAL_EXAMINATION = "PHYSICAL_EXAMINATION",
  PRESCRIPTION = "PRESCRIPTION",
  TEST_REPORT = "TEST_REPORT",
  CLINICAL_DOCUMENTS = "CLINICAL_DOCUMENTS",
}

export enum MedicalTestUnit {
  GM = "GM",
  GM_SLASH_DL = "GM_SLASH_DL",
  NONE = "NONE",
  _PERCENT_ = "_PERCENT_",
}

export enum NonCartOrderOMSCity {
  CHENNAI = "CHENNAI",
}

export enum ONE_APOLLO_STORE_CODE {
  ANDCUS = "ANDCUS",
  IOSCUS = "IOSCUS",
  WEBCUS = "WEBCUS",
}

export enum ORDER_TYPE {
  CONSULT = "CONSULT",
  PHARMACY = "PHARMACY",
}

export enum OTP_STATUS {
  BLOCKED = "BLOCKED",
  EXPIRED = "EXPIRED",
  NOT_VERIFIED = "NOT_VERIFIED",
  VERIFIED = "VERIFIED",
}

export enum PATIENT_ADDRESS_TYPE {
  HOME = "HOME",
  OFFICE = "OFFICE",
  OTHER = "OTHER",
}

export enum PAYMENT_METHODS {
  CC = "CC",
  COD = "COD",
  DC = "DC",
  EMI = "EMI",
  NB = "NB",
  PAYTMCC = "PAYTMCC",
  PPI = "PPI",
  UPI = "UPI",
}

export enum PAYMENT_METHODS_REVERSE {
  COD = "COD",
  CREDIT_CARD = "CREDIT_CARD",
  CREDIT_CARD_EMI = "CREDIT_CARD_EMI",
  DEBIT_CARD = "DEBIT_CARD",
  NET_BANKING = "NET_BANKING",
  PAYTM_POSTPAID = "PAYTM_POSTPAID",
  PAYTM_WALLET = "PAYTM_WALLET",
  UPI = "UPI",
}

export enum PLAN {
  ALL = "ALL",
  CARE_PLAN = "CARE_PLAN",
}

export enum PLAN_STATUS {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum PRISM_DOCUMENT_CATEGORY {
  HealthChecks = "HealthChecks",
  OpSummary = "OpSummary",
  TestReports = "TestReports",
}

export enum PaymentStatus {
  INVALID_PAYMENT = "INVALID_PAYMENT",
  PENDING = "PENDING",
  TXN_FAILURE = "TXN_FAILURE",
  TXN_SUCCESS = "TXN_SUCCESS",
}

export enum PharmaDiscountApplicableOn {
  MRP = "MRP",
  SPECIAL_PRICE = "SPECIAL_PRICE",
}

export enum REFUND_STATUS {
  REFUND_FAILED = "REFUND_FAILED",
  REFUND_REQUEST_NOT_RAISED = "REFUND_REQUEST_NOT_RAISED",
  REFUND_REQUEST_RAISED = "REFUND_REQUEST_RAISED",
  REFUND_SUCCESSFUL = "REFUND_SUCCESSFUL",
}

export enum REQUEST_ROLES {
  ADMIN = "ADMIN",
  DOCTOR = "DOCTOR",
  JUNIOR = "JUNIOR",
  PATIENT = "PATIENT",
  SYSTEM = "SYSTEM",
}

export enum ROUTE_OF_ADMINISTRATION {
  EAR_DROPS = "EAR_DROPS",
  EYE_DROPS = "EYE_DROPS",
  EYE_OINTMENT = "EYE_OINTMENT",
  GARGLE = "GARGLE",
  INHALE = "INHALE",
  INTRAMUSCULAR = "INTRAMUSCULAR",
  INTRANASAL_SPRAY = "INTRANASAL_SPRAY",
  INTRAVAGINAL = "INTRAVAGINAL",
  INTRAVENOUS = "INTRAVENOUS",
  INTRA_ARTICULAR = "INTRA_ARTICULAR",
  LOCAL_APPLICATION = "LOCAL_APPLICATION",
  NASALLY = "NASALLY",
  NASAL_DROPS = "NASAL_DROPS",
  ORALLY = "ORALLY",
  ORAL_DROPS = "ORAL_DROPS",
  PER_RECTAL = "PER_RECTAL",
  SUBCUTANEOUS = "SUBCUTANEOUS",
  SUBLINGUAL = "SUBLINGUAL",
  TRIGGER_POINT_INJECTION = "TRIGGER_POINT_INJECTION",
}

export enum Relation {
  BROTHER = "BROTHER",
  COUSIN = "COUSIN",
  DAUGHTER = "DAUGHTER",
  FATHER = "FATHER",
  GRANDDAUGHTER = "GRANDDAUGHTER",
  GRANDFATHER = "GRANDFATHER",
  GRANDMOTHER = "GRANDMOTHER",
  GRANDSON = "GRANDSON",
  HUSBAND = "HUSBAND",
  ME = "ME",
  MOTHER = "MOTHER",
  OTHER = "OTHER",
  SISTER = "SISTER",
  SON = "SON",
  WIFE = "WIFE",
}

export enum SEARCH_TYPE {
  DOCTOR = "DOCTOR",
  MEDICINE = "MEDICINE",
  SPECIALTY = "SPECIALTY",
  TEST = "TEST",
}

export enum STATUS {
  CALL_ABANDON = "CALL_ABANDON",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  CONFIRMED = "CONFIRMED",
  IN_PROGRESS = "IN_PROGRESS",
  JUNIOR_DOCTOR_ENDED = "JUNIOR_DOCTOR_ENDED",
  JUNIOR_DOCTOR_STARTED = "JUNIOR_DOCTOR_STARTED",
  NO_SHOW = "NO_SHOW",
  PAYMENT_ABORTED = "PAYMENT_ABORTED",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  PAYMENT_PENDING = "PAYMENT_PENDING",
  PAYMENT_PENDING_PG = "PAYMENT_PENDING_PG",
  PENDING = "PENDING",
  PRESCRIPTION_PENDING = "PRESCRIPTION_PENDING",
  UNAVAILABLE_MEDMANTRA = "UNAVAILABLE_MEDMANTRA",
  TRANSFERRED = "TRANSFERRED",
}

export enum SpecialtySearchType {
  ID = "ID",
  NAME = "NAME",
}

export enum SubscriptionStatus {
  ACTIVE = "ACTIVE",
  CANCELLED = "CANCELLED",
  DEFERRED_INACTIVE = "DEFERRED_INACTIVE",
  DISABLED = "DISABLED",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  PAYMENT_PENDING = "PAYMENT_PENDING",
  UPGRADED = "UPGRADED",
}

export enum TEST_COLLECTION_TYPE {
  CENTER = "CENTER",
  HC = "HC",
}

export enum TRANSFER_INITIATED_TYPE {
  DOCTOR = "DOCTOR",
  PATIENT = "PATIENT",
}

export enum TRANSFER_STATUS {
  COMPLETED = "COMPLETED",
  INITIATED = "INITIATED",
  REJECTED = "REJECTED",
}

export enum UPLOAD_FILE_TYPES {
  JPEG = "JPEG",
  JPG = "JPG",
  PDF = "PDF",
  PNG = "PNG",
}

export enum UnitTypes {
  CLINIC = "CLINIC",
  HOSPITAL = "HOSPITAL",
}

export enum UserState {
  LOGGED_IN = "LOGGED_IN",
  LOGGED_OUT = "LOGGED_OUT",
}

export enum WeekDay {
  FRIDAY = "FRIDAY",
  MONDAY = "MONDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
  THURSDAY = "THURSDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
}

export enum mediaPrescriptionSource {
  EPRESCRIPTION = "EPRESCRIPTION",
  SELF = "SELF",
}

export enum notificationEventName {
  APPOINTMENT = "APPOINTMENT",
}

export enum notificationStatus {
  READ = "READ",
  UNREAD = "UNREAD",
}

export enum notificationType {
  CHAT = "CHAT",
}

export enum one_apollo_store_code {
  ANDCUS = "ANDCUS",
  IOSCUS = "IOSCUS",
  WEBCUS = "WEBCUS",
}

export enum PAYMENT_METHODS_JUSPAY_V2 {
  CARD = "CARD",
  COD = "COD",
  CONSUMER_FINANCE = "CONSUMER_FINANCE",
  CRED = "CRED",
  FEATURED_BANKS = "FEATURED_BANKS",
  HEALTH_CREDITS = "HEALTH_CREDITS",
  NB = "NB",
  OTHER_BANKS = "OTHER_BANKS",
  PAY_LATER = "PAY_LATER",
  PREFERRED = "PREFERRED",
  REWARD = "REWARD",
  UPI = "UPI",
  VOUCHER = "VOUCHER",
  WALLET = "WALLET",
}

export interface AddAllergyRecordInput {
  id?: string | null;
  patientId: string;
  recordType: MedicalRecordType;
  allergyName: string;
  severity: AllergySeverity;
  startDate: any;
  endDate?: any | null;
  doctorTreated?: string | null;
  reactionToAllergy?: string | null;
  notes?: string | null;
  attachmentList?: (AllergyFileProperties | null)[] | null;
}

export interface WalletPayment {
  order_id: string;
  payment_method_type: PAYMENT_METHODS_JUSPAY;
  payment_method: string;
  redirect_after_payment: boolean;
  merchant_id?: string | null;
  format?: string | null;
  mobile_number?: string | null;
  txn_type?: WALLET_TXN_TYPE | null;
  direct_wallet_token?: string | null;
  applied_offer_ids?: (string | null)[] | null;
}

export interface GenerateOtpEmailIdInput {
  email?: string | null;
  partnerId?: string | null;
}

export interface ProcessDiagnosticHCOrderInput {
  orderID: string;
  statusDate?: any | null;
  paymentMode?: DIAGNOSTIC_ORDER_PAYMENT_TYPE | null;
  amount: number;
}

export interface AddDiabeticQuestionnaireInput {
  patientId: string;
  plan?: string | null;
  diabetic_type?: string | null;
  diabetic_year?: string | null;
}

export interface AddHealthCheckRecordInput {
  id?: string | null;
  patientId: string;
  recordType: MedicalRecordType;
  healthCheckName: string;
  healthCheckDate: any;
  healthCheckFiles?: (HealthCheckFileProperties | null)[] | null;
}

export interface AddHospitalizationRecordInput {
  id?: string | null;
  patientId: string;
  recordType: MedicalRecordType;
  dischargeDate: any;
  hospitalName: string;
  doctorName: string;
  diagnosisNotes?: string | null;
  hospitalizationFiles?: (HospitalizationFileProperties | null)[] | null;
}

export interface OrderInputV2 {
  payment_order_id: string;
  health_credits_used?: number | null;
  cash_to_collect?: number | null;
  prepaid_amount?: number | null;
  store_code?: ONEAPOLLO_STORECODE | null;
  is_mobile_sdk?: boolean | null;
  return_url?: string | null;
  offer_id_list?: (string | null)[] | null;
  gateway_id?: number | null;
}

export interface AddLabTestRecordInput {
  id?: string | null;
  patientId: string;
  recordType: MedicalRecordType;
  labTestName: string;
  labTestDate: any;
  referringDoctor?: string | null;
  observations?: string | null;
  additionalNotes?: string | null;
  labTestResults?: (LabTestParameters | null)[] | null;
  testResultFiles?: (LabTestFileProperties | null)[] | null;
}

export interface AddMedicalConditionRecordInput {
  id?: string | null;
  patientId: string;
  recordType: MedicalRecordType;
  medicalConditionName: string;
  doctorTreated: string;
  startDate: any;
  endDate?: any | null;
  notes?: string | null;
  illnessType: MedicalConditionIllnessTypes;
  medicationFiles?: (MedicalConditionFileProperties | null)[] | null;
}

export interface AddMedicalRecordInput {
  additionalNotes?: string | null;
  documentURLs?: string | null;
  issuingDoctor?: string | null;
  location?: string | null;
  medicalRecordParameters?: (AddMedicalRecordParametersInput | null)[] | null;
  observations?: string | null;
  patientId: string;
  prismFileIds?: string | null;
  recordType?: MedicalRecordType | null;
  referringDoctor?: string | null;
  sourceName?: string | null;
  testDate?: any | null;
  testName: string;
  testResultFiles?: LabResultFileProperties | null;
}

export interface AddMedicalRecordParametersInput {
  maximum?: number | null;
  minimum?: number | null;
  parameterName?: string | null;
  result?: number | null;
  unit?: MedicalTestUnit | null;
}

export interface AddPatientHealthRestrictionRecordInput {
  id?: string | null;
  patientId: string;
  recordType: MedicalRecordType;
  restrictionName: string;
  startDate: any;
  endDate?: any | null;
  suggestedByDoctor?: string | null;
  nature: HealthRestrictionNature;
  notes?: string | null;
}

export interface AddPatientMedicalBillRecordInput {
  id?: string | null;
  patientId: string;
  recordType: MedicalRecordType;
  hospitalName?: string | null;
  bill_no?: string | null;
  billDate: any;
  notes?: string | null;
  billFiles?: (MedicalBillFileProperties | null)[] | null;
}

export interface AddPatientMedicalInsuranceRecordInput {
  id?: string | null;
  patientId: string;
  recordType: MedicalRecordType;
  insuranceCompany: string;
  policyNumber?: string | null;
  startDate: any;
  endDate: any;
  sumInsured?: string | null;
  insuranceFiles?: (MedicalInsuranceFileProperties | null)[] | null;
  notes?: string | null;
}

export interface AddPatientMedicationRecordInput {
  id?: string | null;
  patientId: string;
  recordType: MedicalRecordType;
  medicineName: string;
  medicalCondition?: string | null;
  doctorName?: string | null;
  startDate: any;
  endDate?: any | null;
  morning?: boolean | null;
  noon?: boolean | null;
  evening?: boolean | null;
  notes?: string | null;
}

export enum PrescriptionSource {
  CONSULTS = "CONSULTS",
  DIAG = "DIAG",
  PHARMA = "PHARMA",
}
export interface AddPrescriptionRecordInput {
  additionalNotes?: string | null;
  dateOfPrescription?: any | null;
  documentId?: string | null;
  id?: string | null;
  isUserNotSelected?: boolean | null;
  issuingDoctor?: string | null;
  location?: string | null;
  mobileNumber?: string | null;
  newUhid?: string | null;
  patientId: string;
  prescriptionFiles?: (prescriptionPrismFileProperties | null)[] | null;
  prescriptionName?: string | null;
  recordType: MedicalRecordType;
  source?: PrescriptionSource | null;
}

export interface AllergyFileProperties {
  fileName?: string | null;
  mimeType?: string | null;
  content?: string | null;
}

export interface AppointmentBookingRequestInput {
  patientId: string;
  doctorId: string;
  appointmentType: APPOINTMENT_TYPE;
  hospitalId: string;
  bookingSource?: BOOKINGSOURCE | null;
  deviceType?: DEVICETYPE | null;
  actualAmount?: number | null;
  discountedAmount?: number | null;
  requestDetail?: REQUEST_DETAIL | null;
}

export interface AppointmentHistoryInput {
  patientId: string;
  doctorId: string;
}

export interface AppointmentPaymentInput {
  mid?: string | null;
  amountPaid: number;
  paymentRefId?: string | null;
  paymentStatus: string;
  paymentDateTime: any;
  responseCode: string;
  responseMessage: string;
  bankTxnId?: string | null;
  orderId?: string | null;
  bankName?: string | null;
  refundAmount?: number | null;
  paymentMode?: PAYMENT_METHODS | null;
  partnerInfo?: string | null;
  planId?: string | null;
  subPlanId?: string | null;
  storeCode?: ONE_APOLLO_STORE_CODE | null;
}

export interface Attachments {
  documentName?: string | null;
  fileName?: string | null;
  documentBase64String?: string | null;
}

export interface BookAppointmentInput {
  patientId: string;
  doctorId: string;
  healthRecordsConsent?: HealthRecordsConsentStatus;
  appointmentDateTime: any;
  appointmentType: APPOINTMENT_TYPE;
  hospitalId: string;
  symptoms?: string | null;
  bookingSource?: BOOKINGSOURCE | null;
  deviceType?: DEVICE_TYPE | null;
  couponCode?: string | null;
  externalConnect?: boolean | null;
  pinCode?: string | null;
  actualAmount?: number | null;
  discountedAmount?: number | null;
  subscriptionDetails?: SUBSCRIPTION_DETAILS | null;
  planPurchaseDetails?: PLAN_PURCHASE_DETAILS | null;
  isFollowUp?: boolean | null;
  followUpParentId?: string | null;
  externalServiceInput?: ExternalServiceInput | null;
  adminId?: string | null;
  userCategory?: string | null;
  allowSimilarPhysicalAppt?: boolean;
}

export interface BookFollowUpAppointmentInput {
  patientId: string;
  doctorId: string;
  appointmentDateTime: any;
  appointmentType: APPOINTMENT_TYPE;
  hospitalId?: string | null;
  followUpParentId: string;
}

export interface BookRescheduleAppointmentInput {
  appointmentId: string;
  doctorId: string;
  newDateTimeslot: any;
  initiatedBy: TRANSFER_INITIATED_TYPE;
  initiatedId: string;
  patientId: string;
  rescheduledId?: string | null;
  rescheduleReason?: string | null;
}

export interface CancelAppointmentInput {
  appointmentId: string;
  cancelReason?: string | null;
  cancelledBy: REQUEST_ROLES;
  cancelledById: string;
}

export interface CancellationDiagnosticsInput {
  comment?: string | null;
  orderId: string;
  patientId: string;
  reason: string;
}

export interface ConsultQueueInput {
  appointmentId: string;
  height?: string | null;
  weight?: string | null;
  temperature?: string | null;
  bp?: string | null;
  lifeStyle?: string | null;
  familyHistory?: string | null;
  dietAllergies?: string | null;
  drugAllergies?: string | null;
  age?: number | null;
  gender?: Gender | null;
}

export interface CouponInput {
  grossOrderAmountExcludingDiscount: number;
  testsOrdered?: (DiagnosticTestsOrdered | null)[] | null;
  cityId: number;
}

export interface CreateUserSubscriptionInput {
  _id?: string | null;
  plan_id: string;
  payment_reference?: PaymentReference | null;
  coupon_availed?: string | null;
  mobile_number: string;
  order_id?: string | null;
  transaction_date_time?: any | null;
  status?: SubscriptionStatus | null;
  start_date?: any | null;
  end_date?: any | null;
  deactivation_date?: any | null;
  CustomerId?: string | null;
  FirstName?: string | null;
  LastName?: string | null;
  Email?: string | null;
  Gender?: Gender | null;
  DOB?: any | null;
  storeCode: one_apollo_store_code;
  sub_plan_id?: string | null;
}

export interface DeleteHealthRecordFilesInput {
  fileIndex?: string | null;
  patientId: string;
  recordType: MedicalRecordType;
  recordId?: string | null;
}

export interface DeletePatientPrismMedicalRecordInput {
  id?: string | null;
  patientId: string;
  recordType: MedicalRecordType;
}

export interface DiagnosticBookHomeCollectionInput {
  patientId: string;
  patientAddressId: string;
  slotTimings: string;
  totalPrice: number;
  prescriptionUrl: string;
  diagnosticDate: any;
  bookingSource?: BOOKINGSOURCE | null;
  deviceType?: DEVICETYPE | null;
  paymentType?: DIAGNOSTIC_ORDER_PAYMENT_TYPE | null;
  items?: (DiagnosticLineItem | null)[] | null;
  slotId: string;
  areaId: number;
  collectionCharges: number;
  uniqueID?: string | null;
  slotDateTimeInUTC?: any | null;
  totalPriceExcludingDiscounts?: number | null;
  userSubscriptionId?: string | null;
  subscriptionInclusionId?: string | null;
  attachmentData?: (Attachments | null)[] | null;
}

export interface DiagnosticLineItem {
  couponDiscAmount?: number | null;
  groupPlan?: string | null;
  itemId?: number | null;
  preTestingRequirement?: string | null;
  price?: number | null;
  quantity?: number | null;
  removed?: boolean | null;
  reportGenerationTime?: string | null;
  testPreparationData?: string | null;
}

export interface DiagnosticOrderInput {
  patientId: string;
  patientAddressId: string;
  city: string;
  cityId: string;
  state: string;
  stateId: string;
  slotTimings: string;
  employeeSlotId?: any | null;
  diagnosticEmployeeCode: string;
  diagnosticBranchCode: string;
  totalPrice: number;
  prescriptionUrl: string;
  diagnosticDate: any;
  centerName: string;
  centerCode: string;
  centerCity: string;
  centerState: string;
  centerLocality: string;
  bookingSource?: BOOKINGSOURCE | null;
  deviceType?: DEVICETYPE | null;
  paymentType?: DIAGNOSTIC_ORDER_PAYMENT_TYPE | null;
  items?: (DiagnosticLineItem | null)[] | null;
  slotId?: string | null;
  areaId?: number | null;
  totalPriceExcludingDiscounts?: number | null;
  userSubscriptionId?: string | null;
  subscriptionInclusionId?: string | null;
}

export interface DiagnosticTestsOrdered {
  itemId?: number | null;
  itemName?: string | null;
  rateExcludingDiscount?: number | null;
  groupPlan?: string | null;
}

export interface DoctorAvailabilityInput {
  availableDate: any;
  doctorId: string;
}

export interface DoctorNextAvailableSlotInput {
  availableDate: any;
  doctorIds: string[];
  availableType?: APPOINTMENT_TYPE | null;
  currentTimeInput?: any | null;
  facilityId?: string;
  afterDateTime?: any;
}

export interface DoctorPhysicalAvailabilityInput {
  availableDate: any;
  doctorId: string;
  facilityId: string;
}

export interface DownloadDocumentsInput {
  fileIds: string[];
  patientId: string;
}

export interface EditProfileInput {
  firstName: string;
  lastName: string;
  dateOfBirth: any;
  gender: Gender;
  relation: Relation;
  emailAddress: string;
  photoUrl: string;
  id: string;
}

export interface FilterDoctorInput {
  patientId?: string | null;
  specialty?: string | null;
  specialtySearchType?: SpecialtySearchType | null;
  specialtyName?: (string | null)[] | null;
  city?: (string | null)[] | null;
  experience?: (Range | null)[] | null;
  availability?: (string | null)[] | null;
  availableNow?: string | null;
  fees?: (Range | null)[] | null;
  gender?: (Gender | null)[] | null;
  language?: (string | null)[] | null;
  geolocation?: Geolocation | null;
  consultMode?: ConsultMode | null;
  pincode?: string | null;
  doctorType?: (string | null)[] | null;
  sort?: string | null;
  pageNo?: number | null;
  pageSize?: number | null;
  searchText?: string | null;
  radius?: number | null;
  isCare?: boolean | null;
}

export interface Geolocation {
  latitude: number;
  longitude: number;
}

export interface HealthCheckFileProperties {
  fileName?: string | null;
  mimeType?: string | null;
  content?: string | null;
}

export interface HelpEmailInput {
  category?: string | null;
  reason?: string | null;
  comments?: string | null;
  patientId?: string | null;
  email?: string | null;
  orderId?: number | null;
  orderType?: ORDER_TYPE | null;
}

export interface HospitalizationFileProperties {
  fileName?: string | null;
  mimeType?: string | null;
  content?: string | null;
}

export interface LabResultFileProperties {
  fileName: string;
  mimeType: string;
  content: string;
}

export interface LabTestFileProperties {
  fileName?: string | null;
  mimeType?: string | null;
  content?: string | null;
}

export interface LabTestParameters {
  maximum?: number | null;
  minimum?: number | null;
  parameterName?: string | null;
  result?: number | null;
  unit?: string | null;
}

export interface MediaPrescriptionFileProperties {
  fileName: string;
  mimeType: string;
  content: string;
}

export interface MediaPrescriptionUploadRequest {
  prescribedBy: string;
  dateOfPrescription: any;
  startDate?: any | null;
  endDate?: any | null;
  notes?: string | null;
  prescriptionSource: mediaPrescriptionSource;
  prescriptionFiles?: (MediaPrescriptionFileProperties | null)[] | null;
}

export enum NB_PAYMENT_BANK {
  NB_ALLB = "NB_ALLB",
  NB_ANDHRA = "NB_ANDHRA",
  NB_AXIS = "NB_AXIS",
  NB_BBKM = "NB_BBKM",
  NB_BHARAT = "NB_BHARAT",
  NB_BOB = "NB_BOB",
  NB_BOBCORP = "NB_BOBCORP",
  NB_BOI = "NB_BOI",
  NB_BOM = "NB_BOM",
  NB_CANR = "NB_CANR",
  NB_CBI = "NB_CBI",
  NB_CITI = "NB_CITI",
  NB_CORP = "NB_CORP",
  NB_COSMOS = "NB_COSMOS",
  NB_CSB = "NB_CSB",
  NB_CUB = "NB_CUB",
  NB_DBS = "NB_DBS",
  NB_DCB = "NB_DCB",
  NB_DCBB = "NB_DCBB",
  NB_DENA = "NB_DENA",
  NB_DEUT = "NB_DEUT",
  NB_DLS = "NB_DLS",
  NB_FED = "NB_FED",
  NB_HDFC = "NB_HDFC",
  NB_ICICI = "NB_ICICI",
  NB_IDBI = "NB_IDBI",
  NB_IDFC = "NB_IDFC",
  NB_INDB = "NB_INDB",
  NB_INDUS = "NB_INDUS",
  NB_ING = "NB_ING",
  NB_IOB = "NB_IOB",
  NB_JNK = "NB_JNK",
  NB_JSB = "NB_JSB",
  NB_KARN = "NB_KARN",
  NB_KOTAK = "NB_KOTAK",
  NB_KVB = "NB_KVB",
  NB_KVBCORP = "NB_KVBCORP",
  NB_LVB = "NB_LVB",
  NB_LVBCORP = "NB_LVBCORP",
  NB_NAIB = "NB_NAIB",
  NB_NKGSB = "NB_NKGSB",
  NB_OBC = "NB_OBC",
  NB_PMCB = "NB_PMCB",
  NB_PNB = "NB_PNB",
  NB_PNBCORP = "NB_PNBCORP",
  NB_PNJSB = "NB_PNJSB",
  NB_RATN = "NB_RATN",
  NB_RBS = "NB_RBS",
  NB_SARASB = "NB_SARASB",
  NB_SBBJ = "NB_SBBJ",
  NB_SBH = "NB_SBH",
  NB_SBI = "NB_SBI",
  NB_SBM = "NB_SBM",
  NB_SBP = "NB_SBP",
  NB_SBT = "NB_SBT",
  NB_SCB = "NB_SCB",
  NB_SOIB = "NB_SOIB",
  NB_SVC = "NB_SVC",
  NB_SVCB = "NB_SVCB",
  NB_SYNB = "NB_SYNB",
  NB_TMB = "NB_TMB",
  NB_TNSC = "NB_TNSC",
  NB_UBI = "NB_UBI",
  NB_UBICORP = "NB_UBICORP",
  NB_UCOB = "NB_UCOB",
  NB_UNIB = "NB_UNIB",
  NB_VJYB = "NB_VJYB",
  NB_YESB = "NB_YESB",
}

export interface NetbankingPayment {
  applied_offer_ids?: (string | null)[] | null;
  format?: string | null;
  order_id: string;
  payment_method: string;
  payment_method_type: PAYMENT_METHODS_JUSPAY;
  redirect_after_payment: boolean;
}

export interface MedicalBillFileProperties {
  fileName?: string | null;
  mimeType?: string | null;
  content?: string | null;
}

export interface MedicalConditionFileProperties {
  fileName?: string | null;
  mimeType?: string | null;
  content?: string | null;
}

export interface MedicalInsuranceFileProperties {
  fileName?: string | null;
  mimeType?: string | null;
  content?: string | null;
}

export interface MedicineCartOMSInput {
  quoteId?: string | null;
  shopId?: string | null;
  tatType?: string | null;
  estimatedAmount?: number | null;
  patientId: string;
  medicineDeliveryType: MEDICINE_DELIVERY_TYPE;
  bookingSource?: BOOKINGSOURCE | null;
  deviceType?: DEVICE_TYPE | null;
  appVersion?: string | null;
  patientAddressId?: string | null;
  devliveryCharges?: number | null;
  prescriptionImageUrl?: string | null;
  prismPrescriptionFileId?: string | null;
  orderTat?: string | null;
  items?: (MedicineCartOMSItem | null)[] | null;
  coupon?: string | null;
  couponDiscount?: number | null;
  productDiscount?: number | null;
  packagingCharges?: number | null;
  showPrescriptionAtStore?: boolean | null;
  shopAddress?: ShopAddress | null;
  customerComment?: string | null;
  storeDistanceKm?: number | null;
  subscriptionDetails?: SUBSCRIPTION_DETAILS_PHARMA | null;
  planPurchaseDetails?: PLAN_PURCHASE_DETAILS_PHARMA | null;
  healthCreditUsed?: number | null;
  totalCashBack?: number | null;
  savedDeliveryCharge?: number | null;
}

export interface MedicineCartOMSItem {
  medicineSKU?: string | null;
  medicineName?: string | null;
  couponFree?: number | null;
  price?: number | null;
  quantity?: number | null;
  mrp?: number | null;
  itemValue?: number | null;
  itemDiscount?: number | null;
  isPrescriptionNeeded?: number | null;
  mou?: number | null;
  isMedicine: string;
  specialPrice: number;
}

export interface MedicineOrderCancelOMSInput {
  orderNo?: number | null;
  cancelReasonCode?: string | null;
  cancelReasonText?: string | null;
}

export interface MedicinePaymentMqInput {
  mid?: string | null;
  orderAutoId: number;
  paymentType: MEDICINE_ORDER_PAYMENT_TYPE;
  amountPaid: number;
  paymentRefId?: string | null;
  refundAmount?: number | null;
  bankName?: string | null;
  paymentStatus?: string | null;
  paymentDateTime?: any | null;
  responseCode?: string | null;
  responseMessage?: string | null;
  bankTxnId?: string | null;
  email?: string | null;
  CODCity?: CODCity | null;
  orderId?: string | null;
  paymentMode?: PAYMENT_METHODS | null;
  healthCredits?: number | null;
  partnerInfo?: string | null;
  planId?: string | null;
  storeCode?: ONE_APOLLO_STORE_CODE | null;
  subPlanId?: string | null;
  payload?: string | null;
  healthCreditsSub?: number | null;
}

export interface MessageInput {
  fromId: string;
  toId: string;
  eventName: notificationEventName;
  eventId: string;
  message: string;
  status: notificationStatus;
  type: notificationType;
  source?: TRANSFER_INITIATED_TYPE | null;
}

export interface OrderLineItems {
  itemId: string;
  mrp: number;
  productName: string;
  productType: CouponCategoryApplicable;
  quantity: number;
  specialPrice: number;
  couponFree?: number | null;
}

export interface OtpVerificationInput {
  id: string;
  otp: string;
  loginType: LOGIN_TYPE;
}

export interface PLAN_PURCHASE_DETAILS {
  TYPE?: PLAN | null;
  PlanAmount?: number | null;
}

export interface PLAN_PURCHASE_DETAILS_PHARMA {
  TYPE?: PLAN | null;
  PlanAmount?: number | null;
  planId?: string | null;
  subPlanId?: string | null;
}

export interface PatientAddressInput {
  patientId: string;
  name?: string | null;
  addressLine1: string;
  addressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  zipcode: string;
  mobileNumber?: string | null;
  landmark?: string | null;
  addressType?: PATIENT_ADDRESS_TYPE | null;
  otherAddressType?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  stateCode?: string | null;
  defaultAddress?: boolean | null;
}

export interface PatientAppointmentsInput {
  patientId: string;
  appointmentDate: any;
}

export interface PatientConsultsAndOrdersInput {
  patient: string;
  filter?: CONSULTS_RX_SEARCH_FILTER[] | null;
  offset?: number | null;
  limit?: number | null;
}

export interface PatientFeedbackInput {
  patientId: string;
  rating?: string | null;
  thankyouNote?: string | null;
  reason?: string | null;
  feedbackType?: FEEDBACKTYPE | null;
  transactionId: string;
}

export interface PatientMedicalParameters {
  patientId: string;
  height?: string | null;
  weight?: string | null;
  bloodGroup?: BloodGroups | null;
}

export interface PatientProfileInput {
  firstName: string;
  lastName: string;
  dateOfBirth: any;
  gender: Gender;
  relation: Relation;
  emailAddress: string;
  photoUrl: string;
  mobileNumber: string;
}

export interface PaymentReference {
  mid?: string | null;
  amount_paid?: number | null;
  payment_status?: PaymentStatus | null;
  payment_reference_id?: string | null;
  purchase_via_HC?: boolean | null;
  HC_used?: number | null;
  ORDERID?: string | null;
  TXNAMOUNT?: string | null;
  PAYMENTMODE?: string | null;
  CURRENCY?: string | null;
  TXNDATE?: any | null;
  RESPCODE?: string | null;
  RESPMSG?: string | null;
  MERC_UNQ_REF?: string | null;
  GATEWAYNAME?: string | null;
  BANKTXNID?: string | null;
  BANKNAME?: string | null;
  coupon_used_details?: coupon_used_details;
}

interface coupon_used_details {
  bill_amount: any;
  discount_amount: number;
  coupon_code: string;
}

export interface PharmaCouponInput {
  code: string;
  patientId: string;
  orderLineItems?: (OrderLineItems | null)[] | null;
}

export interface PrescriptionMedicineOrderOMSInput {
  quoteId?: string | null;
  shopId?: string | null;
  patientId: string;
  bookingSource?: BOOKING_SOURCE | null;
  deviceType?: DEVICE_TYPE | null;
  appVersion?: string | null;
  medicineDeliveryType: MEDICINE_DELIVERY_TYPE;
  patinetAddressId?: string | null;
  prescriptionImageUrl: string;
  prismPrescriptionFileId: string;
  appointmentId?: string | null;
  isEprescription?: number | null;
  payment?: PrescriptionMedicinePaymentOMSDetails | null;
  email?: string | null;
  NonCartOrderCity?: NonCartOrderOMSCity | null;
  orderAutoId?: number | null;
  shopAddress?: ShopAddress | null;
  prescriptionOptionSelected?: string | null;
  durationDays?: number | null;
  customerComment?: string | null;
}

export interface PrescriptionMedicinePaymentOMSDetails {
  paymentType?: MEDICINE_ORDER_PAYMENT_TYPE | null;
  amountPaid?: number | null;
  paymentRefId?: string | null;
  paymentStatus?: string | null;
  paymentDateTime?: any | null;
}

export interface REQUEST_DETAIL {
  preferredDateText?: string | null;
}

export interface Range {
  minimum?: number | null;
  maximum?: number | null;
}

export interface SUBSCRIPTION_DETAILS {
  userSubscriptionId?: string | null;
  plan?: PLAN | null;
  planId?: string | null;
  groupPlanId?: string | null;
}

export interface SUBSCRIPTION_DETAILS_PHARMA {
  userSubscriptionId?: string | null;
}

export interface SavePharmacologistConsultInput {
  patientId: string;
  prescriptionImageUrl?: string | null;
  emailId: string;
  queries?: string | null;
}

export interface SaveSearchInput {
  type?: SEARCH_TYPE | null;
  typeId: string;
  typeName?: string | null;
  image?: string | null;
  patient: string;
}

export interface ShopAddress {
  storename?: string | null;
  address?: string | null;
  workinghrs?: string | null;
  phone?: string | null;
  city?: string | null;
  state?: string | null;
  zipcode?: string | null;
  stateCode?: string | null;
}

export interface UpdateAppointmentSessionInput {
  appointmentId: string;
  requestRole: string;
}

export interface UpdatePatientAddressInput {
  id: string;
  name?: string | null;
  addressLine1: string;
  addressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  zipcode: string;
  mobileNumber?: string | null;
  landmark?: string | null;
  addressType?: PATIENT_ADDRESS_TYPE | null;
  otherAddressType?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  stateCode?: string | null;
  defaultAddress?: boolean | null;
}

export interface UpdatePatientInput {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  mobileNumber?: string | null;
  gender?: Gender | null;
  uhid?: string | null;
  emailAddress?: string | null;
  dateOfBirth?: any | null;
  referralCode?: string | null;
  relation?: Relation | null;
  photoUrl?: string | null;
  deviceCode?: string | null;
  employeeId?: string | null;
  partnerId?: string | null;
  externalAuthId?: string | null;
  whatsappOptIn?: boolean | null;
}

export interface UploadDocumentInput {
  fileType: UPLOAD_FILE_TYPES;
  base64FileInput: string;
  patientId: string;
  category: PRISM_DOCUMENT_CATEGORY;
}

export interface VerifyExternalAuthTokenInput {
  externalAuthToken: string;
}

export interface prescriptionPrismFileProperties {
  fileName?: string | null;
  mimeType?: string | null;
  content?: string | null;
}

export enum GENDER {
  All = "All",
  Female = "Female",
  Male = "Male",
}

export enum BookingSource {
  Apollo247_Android = "Apollo247_Android",
  Apollo247_Ios = "Apollo247_Ios",
  Apollo247_Web = "Apollo247_Web",
}

export enum BookingStatus {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  INPROGRESS = "INPROGRESS",
}

export interface AppointmentInputs {
  price: number;
  appointmentStartDateTimeUTC: any;
  appointmentEndDateTimeUTC: any;
  patientId: string;
  bookingSource: BookingSource;
  hospitalId: string;
  packageId: string;
  packageCategoryId: string;
  cityId: string;
}

export interface AppointmentInputsHospital {
  appointmentEndDateTimeUTC?: any | null;
  appointmentStartDateTimeUTC?: any | null;
  bookingSource?: BookingSource | null;
  cityId?: string | null;
  cityName?: string | null;
  hospitalName?: string | null;
  packageName?: string | null;
  patientId?: string | null;
  price?: number | null;
  serviceId?: number | null;
  slotId?: number | null;
  slotTime?: string | null;
}

export enum ProhealthUnitType {
  CLINIC = "CLINIC",
  HOSPITAL = "HOSPITAL",
}

export enum ZoneType {
  CITY = "CITY",
  STATE = "STATE",
}

export enum PAYMENT_MODE {
  COD = "COD",
  PREPAID = "PREPAID",
}
export interface CreateUserSubscriptionTransactionsInput {
  user_subscription_id?: string | null;
  amount?: number | null;
  source_transaction_indentifier?: string | null;
  transaction_type: TransactionType;
  transaction_date: any;
  subscription_inclusion_id?: string | null;
  mobile_number: string;
  order_id?: string | null;
  payment_reference_id?: string | null;
  coupon_availed?: string | null;
  email?: string | null;
  dob?: any | null;
  partnerId?: string | null;
  meta?: any | null;
  payment_reference?: TransactionPaymentReference | null;
}

export interface TransactionPaymentReference {
  actual_amount?: number | null;
  amount_paid?: number | null;
  payment_status?: string | null;
  payment_reference_id?: string | null;
  purchase_via_HC?: boolean | null;
  HC_used?: number | null;
  order_id?: string | null;
  delivery_charges?: number | null;
  cashbackEarned?: number | null;
  couponDiscount?: number | null;
  deliveryChargesSaved?: number | null;
  activeSubscriptions?: string[] | null;
}

export enum TransactionType {
  CONSULT = "CONSULT",
  DIAGNOSTICS = "DIAGNOSTICS",
  PHARMA = "PHARMA",
}

export interface CreateUserVaccineResponseInput {
  type?: string | null;
  name?: string | null;
  vaccine_name?: string | null;
  gender?: string | null;
  dob?: any | null;
  city?: string | null;
  id_card_type?: string | null;
  id_card_number?: string | null;
  mobile_number: string;
  formdata?: any | null;
}

export interface ParsedFaqData {
  id: string;
  faqQuestion: string;
  faqAnswer: string;
}
export interface FooterLink {
  title: string;
  url: string;
}
export interface FooterLinks {
  [key: string]: FooterLink[];
}
export interface StructuredSchema {
  "@context"?: "https://schema.org";
  "@type": "Question" | "Answer" | "FAQPage" | "ItemList" | "ListItem";
}
export interface StructuredSchemaAnswer extends StructuredSchema {
  text: string;
}
export interface StructuredSchemaQuestion extends StructuredSchema {
  name: string;
  answerCount?: number | string;
  acceptedAnswer: StructuredSchemaAnswer;
}
export interface ListItemStructuredSchema extends StructuredSchema {
  position: number;
  url: string;
  name: string;
}
export interface FAQStructuredSchema extends StructuredSchema {
  mainEntity: StructuredSchemaQuestion[];
}
export interface QAStructuredSchema extends StructuredSchema {
  mainEntity: StructuredSchemaQuestion;
}
export interface ItemListStructuredSchema extends StructuredSchema {
  itemListElement: ListItemStructuredSchema[];
}

export enum MS_TEAM_CALENDAR_TYPE {
  CONSULTANCY = "CONSULTANCY",
  DIAGNOSTIC = "DIAGNOSTIC",
}

export interface PatientLocation {
  city?: string | null;
  pincode?: number | null;
}
export interface UpdateAppointmentInput {
  appointmentId: string;
  patientLocation?: PatientLocation | null;
  paymentOrderId?: string | null;
  status?: STATUS | null;
  discountedAmount?: number | null;
  actualAmount?: number | null;
  chatId?: String | null;
}

export interface MsTeamCalendarEventInput {
  orderId: string;
  calendarEventFor?: MS_TEAM_CALENDAR_TYPE | null;
  summary: string;
  content?: string | null;
  startDateTime: string;
  endDateTime: string;
}

export enum GET_ALL_SPECIALITIES_TYPE {
  ALL = "ALL",
  TRUE = "TRUE",
}
export enum ONEAPOLLO_STORECODE {
  ANDCUS = "ANDCUS",
  IOSCUS = "IOSCUS",
  WEBCUS = "WEBCUS",
}

export interface AuditInput {
  paymentOrderId: string;
  source: ONEAPOLLO_STORECODE;
  sdkOrWebResponse: SdkOrWebResponse;
  version: string;
  transactionId?: string | null;
}

export interface SdkOrWebResponse {
  status: string;
  return_url?: string | null;
  action?: string | null;
  orderId?: string | null;
  error?: boolean | null;
  errorCode?: string | null;
}

export enum DIAGNOSTICS_GROUPPLAN {
  ALL = "ALL",
  CIRCLE = "CIRCLE",
  SPECIALDISCOUNTS = "SPECIALDISCOUNTS",
}

export enum DIAGNOSTIC_ORDER_STATUS {
  CANCELLATION_REQUESTED = "CANCELLATION_REQUESTED",
  DEPT_RECEIVED = "DEPT_RECEIVED",
  IN_PROGRESS = "IN_PROGRESS",
  LEAD_DROPPED = "LEAD_DROPPED",
  NEW_LEAD = "NEW_LEAD",
  ORDER_CANCELLED = "ORDER_CANCELLED",
  ORDER_CANCELLED_REQUEST = "ORDER_CANCELLED_REQUEST",
  ORDER_COMPLETED = "ORDER_COMPLETED",
  ORDER_FAILED = "ORDER_FAILED",
  ORDER_INITIATED = "ORDER_INITIATED",
  ORDER_MODIFIED = "ORDER_MODIFIED",
  ORDER_PLACED = "ORDER_PLACED",
  ORDER_RESCHEDULED = "ORDER_RESCHEDULED",
  ORDER_RESCHEDULED_REQUEST = "ORDER_RESCHEDULED_REQUEST",
  OUT_SOURCE_TEST = "OUT_SOURCE_TEST",
  PARTIAL_DEPT_RECEIVED = "PARTIAL_DEPT_RECEIVED",
  PARTIAL_ORDER_COMPLETED = "PARTIAL_ORDER_COMPLETED",
  PARTIAL_REFUND_INITIATED = "PARTIAL_REFUND_INITIATED",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  PAYMENT_PENDING = "PAYMENT_PENDING",
  PAYMENT_SUCCESSFUL = "PAYMENT_SUCCESSFUL",
  PHLEBO_CHECK_IN = "PHLEBO_CHECK_IN",
  PHLEBO_COMPLETED = "PHLEBO_COMPLETED",
  PICKUP_CONFIRMED = "PICKUP_CONFIRMED",
  PICKUP_REQUESTED = "PICKUP_REQUESTED",
  REFUND_INITIATED = "REFUND_INITIATED",
  REFUND_REQUEST_INITIATED = "REFUND_REQUEST_INITIATED",
  REPORT_GENERATED = "REPORT_GENERATED",
  RERUN = "RERUN",
  RESAMPLE_INITIATED = "RESAMPLE_INITIATED",
  SAMPLE_COLLECTED = "SAMPLE_COLLECTED",
  SAMPLE_COLLECTED_IN_LAB = "SAMPLE_COLLECTED_IN_LAB",
  SAMPLE_NOT_COLLECTED_IN_LAB = "SAMPLE_NOT_COLLECTED_IN_LAB",
  SAMPLE_RECEIVED_IN_LAB = "SAMPLE_RECEIVED_IN_LAB",
  SAMPLE_REJECTED = "SAMPLE_REJECTED",
  SAMPLE_REJECTED_IN_LAB = "SAMPLE_REJECTED_IN_LAB",
  SAMPLE_SUBMITTED = "SAMPLE_SUBMITTED",
  SAMPLE_TESTED = "SAMPLE_TESTED",
}

export interface DiagnosticsServiceability {
  cityID?: number | null;
  stateID?: number | null;
}

export enum DiagnosticsBookingSource {
  MOBILE = "MOBILE",
  OP_CALL_CENTER = "OP_CALL_CENTER",
  OP_CAMP = "OP_CAMP",
  OP_CAMPAIGN = "OP_CAMPAIGN",
  OP_CLINIC = "OP_CLINIC",
  OP_OMT_TEAM = "OP_OMT_TEAM",
  OP_PARTNER = "OP_PARTNER",
  OP_PHARMACY_BUDUPPAL = "OP_PHARMACY_BUDUPPAL",
  OP_PHARMACY_MANIKONDA = "OP_PHARMACY_MANIKONDA",
  OP_PHARMACY_MOTINAGAR = "OP_PHARMACY_MOTINAGAR",
  OP_PHARMACY_NALLAGANDA = "OP_PHARMACY_NALLAGANDA",
  OP_PHARMACY_TELECOMNAGAR_GACHIBOWLI = "OP_PHARMACY_TELECOMNAGAR_GACHIBOWLI",
  OP_SKITAI = "OP_SKITAI",
  OP_STORE = "OP_STORE",
  OP_WHATSAPP = "OP_WHATSAPP",
  WEB = "WEB",
}

export interface slotDetail {
  slotDisplayTime?: string | null;
  internalSlots?: (string | null)[] | null;
}

export interface diagnosticLineItem {
  couponDiscAmount?: number | null;
  groupPlan?: DIAGNOSTICS_GROUPPLAN | null;
  groupPlanDiscAmount?: number | null;
  itemId: number;
  mrp: number;
  preTestingRequirement?: string | null;
  price: number;
  reportGenerationTime?: string | null;
}

export interface patientObjWithLineItems {
  patientID: string;
  lineItems?: (diagnosticLineItem | null)[] | null;
  totalPrice: number;
}

export interface slotInfo {
  slotDetails?: slotDetail | null;
  status?: number | null;
  phleboID?: number | null;
  paidSlot?: boolean | null;
}
export interface phleboCharges {
  charges: number;
  distanceCharges?: number | null;
  couponDiscApplied?: boolean | null;
}

export interface recommendationInputItem {
  itemId?: number | null;
  itemType?: ITEM_TYPE | null;
}

export enum REPORT_TAT_SOURCE {
  CART_PAGE = "CART_PAGE",
  TEST_DETAILS_PAGE = "TEST_DETAILS_PAGE",
}

export enum HealthRecordsConsentStatus {
  GRANTED = "GRANTED",
  NOT_APPLICABLE = "NOT_APPLICABLE",
  NOT_GRANTED = "NOT_GRANTED",
}
export interface OrderInputV2 {
  payment_order_id: string;
  health_credits_used?: number | null;
  cash_to_collect?: number | null;
  prepaid_amount?: number | null;
  store_code?: ONEAPOLLO_STORECODE | null;
  is_mobile_sdk?: boolean | null;
  return_url?: string | null;
  offer_id_list?: (string | null)[] | null;
  gateway_id?: number | null;
}

export interface OrderInput {
  payment_order_id: string;
  payment_mode?: PAYMENT_MODE | null;
  is_mobile_sdk?: boolean | null;
  return_url?: string | null;
  gateway_id?: number | null;
}

export enum PAYMENT_GATEWAYS {
  PAYTM_MINIAPP = "PAYTM_MINIAPP",
  PHONEPE_MINIAPP = "PHONEPE_MINIAPP",
}

export enum PLATFORMS {
  MOBILE = "MOBILE",
  WEB = "WEB",
}

export interface OrderCreate {
  customer_id?: any | null;
  encrypted_order_id_expiry?: number | null;
  orders: OrderVerticals;
  payment_gateway?: PAYMENT_GATEWAYS | null;
  payment_instrument_preference?: PaymentInstrumentPreferenceInput | null;
  platform?: PLATFORMS | null;
  previous_payment_order_id?: string | null;
  total_amount: number;
}

export interface OrderVerticals {
  consult?: (OrderInputEntity | null)[] | null;
  diagnostics?: (OrderInputEntity | null)[] | null;
  pharma?: (OrderInputEntity | null)[] | null;
  subscription?: (OrderInputEntity | null)[] | null;
  vaccination?: (OrderInputEntity | null)[] | null;
}

export interface OrderInputEntity {
  amount: number;
  meta_data?: OrderInputEntityMetaData | null;
  order_id: string;
  patient_id: any;
}

export interface OrderInputEntityMetaData {
  coupon_info?: CouponInfo | null;
}

export interface OffersCustomer {
  id?: string | null;
  phone?: string | null;
  email?: string | null;
  location?: string | null;
  udf1?: string | null;
  udf2?: string | null;
  udf3?: string | null;
  udf4?: string | null;
  udf5?: string | null;
}

export interface OffersOrder {
  order_id: string;
  amount?: string | null;
  currency?: string | null;
  product_id?: string | null;
  udf1?: string | null;
  udf2?: string | null;
  udf3?: string | null;
  udf4?: string | null;
  udf5?: string | null;
  udf6?: string | null;
  udf7?: string | null;
  udf8?: string | null;
  udf9?: string | null;
  udf10?: string | null;
  order_type?: string | null;
}

export interface OffersRequest {
  order: OffersOrder;
  payment_method_info?: (PaymentMethodInfoEntity | null)[] | null;
  customer?: OffersCustomer | null;
}

export interface PaymentMethodInfoEntity {
  payment_method_type?: PAYMENT_METHODS_JUSPAY | null;
  payment_method_reference?: string | null;
  payment_method?: string | null;
  card_variant?: string | null;
  card_type?: string | null;
  card_bin?: string | null;
  card_alias?: string | null;
  bank_code?: string | null;
  auth_type?: string | null;
  issuer?: string | null;
  is_emi?: string | null;
  emi_bank?: string | null;
  emi_tenure?: string | null;
  upi_vpa?: string | null;
  txn_type?: string | null;
  express_checkout?: string | null;
  upi_app?: string | null;
  payment_channel?: string | null;
  emi_type?: string | null;
  metadata?: string | null;
}

export interface GetDiagnosticPackageRecommendationsRequest {
  cityId: number;
  genderFilters?: (Gender | null)[] | null;
  groupPlan?: DIAGNOSTICS_GROUPPLAN | null;
  patientId?: string | null;
  recommendationInputItems: (recommendationInputItem | null)[];
}

export interface RadiologyBookingParams {
  appointmentDate?: any | null;
  department: string;
  location: string;
  mobileNumber: string;
  prescriptionLink?: string | null;
  test: string;
  testId: string;
  unitId: string;
  userName: string;
}

export enum RadiologyUnitTypes {
  CLINIC = "CLINIC",
  HOSPITAL = "HOSPITAL",
}

export interface radiologyPrescriptionFileProperties {
  content: string;
  mimeType: string;
}

export enum PAYMENT_METHODS_STATES {
  CLOSE = "CLOSE",
  OPEN = "OPEN",
}

export interface RescheduleSlot {
  comment?: string | null;
  parentOrderID?: string | null;
  reason?: string | null;
  selectedDate?: any | null;
  slotInfo?: slotInfo | null;
  source?: DiagnosticsRescheduleSource | null;
}

export interface SaveBookHomeCollectionOrderInputv2 {
  agentLoginID?: string | null;
  bookingSource: DiagnosticsBookingSource;
  caseSheets?: (string | null)[] | null;
  collectionCharges: phleboCharges;
  couponCode?: string | null;
  deviceType: DEVICETYPE;
  isCirclePurchase?: boolean | null;
  isNonCartFlow?: boolean | null;
  overrideCouponMrpValidation?: boolean | null;
  packageIds?: (string | null)[] | null;
  patientAddressID: string;
  patientObjWithLineItems?: (patientObjWithLineItems | null)[] | null;
  resampledOrderId?: string | null;
  resendPaymentLink?: boolean | null;
  resendPaymentLinkParentOrderId?: string | null;
  selectedDate: any;
  serviceability: DiagnosticsServiceability;
  slotByClusterConfig?: boolean | null;
  slotInfo?: slotInfo | null;
  storeId?: string | null;
  subscriptionInclusionId?: string | null;
  triggerPaymentLink?: boolean | null;
  userSubscription?: DiagnosticsUserSubscriptionInput | null;
  userSubscriptionId?: string | null;
}

export interface DiagnosticsUserSubscriptionInput {
  amount: number;
  plan_id: string;
  source_meta_data: DiagnosticsSourceMetaData;
  sub_plan_id: string;
  transaction_date_time: any;
}

export interface DiagnosticsSourceMetaData {
  purchase_type?: PlanPurchaseType | null;
}

export enum PlanPurchaseType {
  first_time = "first_time",
  renew = "renew",
}

export interface saveModifyDiagnosticOrderInput {
  orderId?: string | null;
  amountToPay?: number | null;
  collectionCharges?: number | null;
  bookingSource?: DiagnosticsBookingSource | null;
  deviceType?: DEVICETYPE | null;
  items?: (DiagnosticLineItem | null)[] | null;
  userSubscriptionId?: string | null;
  downSellAmountRefund?: number | null;
  overrideCouponMrpValidation?: boolean | null;
  patientId?: string | null;
  rescheduleSlot?: RescheduleSlot | null;
  subscriptionInclusionId?: string | null;
}

export interface patientAddressObj {
  patientAddressID: string;
  latitude: number;
  longitude: number;
  city: string;
  state: string;
  landmark?: string | null;
  addressLine1: string;
  addressLine2: string;
  zipcode: string;
}
export interface ChargeDetailsInput {
  patientAddressObj: patientAddressObj;
  patientsObjWithLineItems: (patientObjWithLineItems | null)[];
  billAmount: number;
  serviceability?: DiagnosticsServiceability | null;
  slotInfo?: slotInfo | null;
  diagnosticOrdersId?: string | null;
}

export interface ProcessDiagnosticHCOrderInputCOD {
  orderID: string;
  statusDate?: any | null;
  amount: number;
}

export interface PassportDetailsInput {
  passportNo?: string | null;
  displayId?: number | null;
}

export enum DiagnosticsRescheduleSource {
  AD = "AD",
  MOBILE = "MOBILE",
  OPS_DASHBOARD = "OPS_DASHBOARD",
  WEB = "WEB",
}

export interface CancellationDiagnosticsInputv2 {
  comment?: string | null;
  orderIds: (string | null)[];
  patientId: string;
  reason: string;
  allowCancellationRequest: boolean;
}

export enum ORDER_STATUS {
  AUTHENTICATION_FAILED = "AUTHENTICATION_FAILED",
  AUTHORIZATION_FAILED = "AUTHORIZATION_FAILED",
  AUTHORIZING = "AUTHORIZING",
  AUTO_REFUNDED = "AUTO_REFUNDED",
  CAPTURE_FAILED = "CAPTURE_FAILED",
  CAPTURE_INITIATED = "CAPTURE_INITIATED",
  CHARGED = "CHARGED",
  COD_COMPLETE = "COD_COMPLETE",
  CREATED = "CREATED",
  JUSPAY_DECLINED = "JUSPAY_DECLINED",
  NEW = "NEW",
  PENDING_VBV = "PENDING_VBV",
  STARTED = "STARTED",
  VOIDED = "VOIDED",
  VOID_FAILED = "VOID_FAILED",
  VOID_INITIATED = "VOID_INITIATED",
}

export enum CANCELLATION_REASONS_CTA {
  ADD_TESTS = "ADD_TESTS",
  EDIT_PATIENT_DETAILS = "EDIT_PATIENT_DETAILS",
  RESCHEDULE = "RESCHEDULE",
  SAME_DAY = "SAME_DAY",
  WITHIN_24_HOURS = "WITHIN_24_HOURS",
  CHOOSE_ANOTHER = "CHOOSE_ANOTHER",
  MODIFY_PATIENT = "MODIFY_PATIENT",
}

export enum CASHBACK_TYPE {
  ABSOLUTE = "ABSOLUTE",
  PERCENT = "PERCENT",
}

export enum CSATFeedback {
  GOOD = "GOOD",
  GREAT = "GREAT",
  OKAY = "OKAY",
  POOR = "POOR",
}

export interface SubscriptionDetailsInput {
  specialtyName?: string | null;
  benefitId?: string | null;
  userSubscriptionId?: string | null;
  planId?: string | null;
  subPlanId?: string | null;
  paymentOrderId?: string | null;
  subscriptionSubPlanId?: string | null;
}

export interface OrderInputV3 {
  card_number?: string | null;
  card_pin?: string | null;
  cash_to_collect?: number | null;
  gateway_id?: number | null;
  health_credits_used?: number | null;
  is_mobile_sdk?: boolean | null;
  offer_id_list?: (string | null)[] | null;
  payment_method?: CREATE_ORDER_PAYMENT_METHOD | null;
  payment_method_type?: PAYMENT_METHODS_JUSPAY | null;
  payment_order_id: string;
  prepaid_amount?: number | null;
  return_url?: string | null;
  store_code?: ONEAPOLLO_STORECODE | null;
  voucher_amount?: number | null;
}

export enum PAY_LATER_PAYMENT_FLOW {
  FIRST_LINK_THEN_PAY = "FIRST_LINK_THEN_PAY",
  LINK_AND_PAY = "LINK_AND_PAY",
}
export enum ACTIVE_ITEMS_STATUS {
  ALL_ITEMS_ACTIVE = "ALL_ITEMS_ACTIVE",
  ALL_ITEMS_INACTIVE = "ALL_ITEMS_INACTIVE",
  PARTIALLY_ACTIVE = "PARTIALLY_ACTIVE",
}

export interface CreateWallet {
  gateway: string;
  mobile_number?: string | null;
}

export interface addTopUpRequest {
  amount: number;
  is_pharma_juspay: boolean;
  payment_order_id: string;
  return_url: string;
  wallet_id: string;
}

export enum MOCKED_TRANSACTION_STATUSES {
  FAILED = "FAILED",
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
}

export enum CREATE_ORDER_PAYMENT_METHOD {
  AIRTELMONEY = "AIRTELMONEY",
  AMAZONPAY = "AMAZONPAY",
  CARD = "CARD",
  FREECHARGE = "FREECHARGE",
  GOOGLEPAY = "GOOGLEPAY",
  JANACASH = "JANACASH",
  JIOMONEY = "JIOMONEY",
  LAZYPAY = "LAZYPAY",
  MOBIKWIK = "MOBIKWIK",
  NB_ALLB = "NB_ALLB",
  NB_ANDHRA = "NB_ANDHRA",
  NB_AXIS = "NB_AXIS",
  NB_BBKM = "NB_BBKM",
  NB_BHARAT = "NB_BHARAT",
  NB_BOB = "NB_BOB",
  NB_BOBCORP = "NB_BOBCORP",
  NB_BOI = "NB_BOI",
  NB_BOM = "NB_BOM",
  NB_CANR = "NB_CANR",
  NB_CBI = "NB_CBI",
  NB_CITI = "NB_CITI",
  NB_CORP = "NB_CORP",
  NB_COSMOS = "NB_COSMOS",
  NB_CSB = "NB_CSB",
  NB_CUB = "NB_CUB",
  NB_DBS = "NB_DBS",
  NB_DCB = "NB_DCB",
  NB_DCBB = "NB_DCBB",
  NB_DENA = "NB_DENA",
  NB_DEUT = "NB_DEUT",
  NB_DLS = "NB_DLS",
  NB_FED = "NB_FED",
  NB_HDFC = "NB_HDFC",
  NB_ICICI = "NB_ICICI",
  NB_IDBI = "NB_IDBI",
  NB_IDFC = "NB_IDFC",
  NB_INDB = "NB_INDB",
  NB_INDUS = "NB_INDUS",
  NB_ING = "NB_ING",
  NB_IOB = "NB_IOB",
  NB_JNK = "NB_JNK",
  NB_JSB = "NB_JSB",
  NB_KARN = "NB_KARN",
  NB_KOTAK = "NB_KOTAK",
  NB_KVB = "NB_KVB",
  NB_KVBCORP = "NB_KVBCORP",
  NB_LVB = "NB_LVB",
  NB_LVBCORP = "NB_LVBCORP",
  NB_NAIB = "NB_NAIB",
  NB_NKGSB = "NB_NKGSB",
  NB_OBC = "NB_OBC",
  NB_PMCB = "NB_PMCB",
  NB_PNB = "NB_PNB",
  NB_PNBCORP = "NB_PNBCORP",
  NB_PNJSB = "NB_PNJSB",
  NB_RATN = "NB_RATN",
  NB_RBS = "NB_RBS",
  NB_SARASB = "NB_SARASB",
  NB_SBBJ = "NB_SBBJ",
  NB_SBH = "NB_SBH",
  NB_SBI = "NB_SBI",
  NB_SBM = "NB_SBM",
  NB_SBP = "NB_SBP",
  NB_SBT = "NB_SBT",
  NB_SCB = "NB_SCB",
  NB_SOIB = "NB_SOIB",
  NB_SVC = "NB_SVC",
  NB_SVCB = "NB_SVCB",
  NB_SYNB = "NB_SYNB",
  NB_TMB = "NB_TMB",
  NB_TNSC = "NB_TNSC",
  NB_UBI = "NB_UBI",
  NB_UBICORP = "NB_UBICORP",
  NB_UCOB = "NB_UCOB",
  NB_UNIB = "NB_UNIB",
  NB_VJYB = "NB_VJYB",
  NB_YESB = "NB_YESB",
  OLAMONEY = "OLAMONEY",
  OXIGEN = "OXIGEN",
  PAYPAL = "PAYPAL",
  PAYTM = "PAYTM",
  PAYUMONEY = "PAYUMONEY",
  PAYZAPP = "PAYZAPP",
  PHONEPE = "PHONEPE",
  SIMPL = "SIMPL",
  UPI_COLLECT = "UPI_COLLECT",
  UPI = "UPI",
}

export interface CardPayment {
  applied_offer_ids?: (string | null)[] | null;
  card_security_code: string;
  card_token: string;
  format?: string | null;
  order_id: string;
  payment_method_type: PAYMENT_METHODS_JUSPAY;
  redirect_after_payment: boolean;
  save_to_locker: boolean;
}

export enum TIME_TO_CONSULT {
  NOW = "Now",
  TODAY = "Today",
  TOMORROW = "Tomorrow",
  NEXT_DAYS = "Next 3 days",
}

export enum CONSULTATION_MODE {
  CONSULT_MODE = "consultMode",
}

export interface ExternalServiceInput {
  metadata?: AppointmentMetaDataInput | null;
  name?: AppointmentProjectType | null;
}

export enum AppointmentProjectType {
  AMAZON_TANGO = "AMAZON_TANGO",
  ASK_APOLLO = "ASK_APOLLO",
  PHARMA = "PHARMA",
}

export interface AppointmentMetaDataInput {
  appointmentProjectType?: AppointmentProjectType | null;
  callDetails?: (CallDetailsInput | null)[] | null;
  comsAppointmentId?: string | null;
  comsPrescription?: ComsPrescriptionInput | null;
  medicines?: (MedicineObjectInput | null)[] | null;
  patientDetails?: PatientMetaDataInput | null;
  provider?: COMS_PROVIDER | null;
  providerConsultationId?: string | null;
  receivedAt?: number | null;
  sympAIChatId?: string | null;
}

export interface PatientMetaDataInput {
  age?: number | null;
  firstName?: string | null;
  gender?: Gender | null;
  id: string;
}

export enum COMS_PROVIDER {
  AMAZON = "AMAZON",
}

export interface MedicineObjectInput {
  name?: string | null;
  orderedQuantity?: number | null;
  sku?: string | null;
}

export interface MedicineObjectInput {
  name?: string | null;
  orderedQuantity?: number | null;
  sku?: string | null;
}

export interface COMS_REQUESTED_PRESCRIPTION_INPUT {
  documentId?: string | null;
  format?: string | null;
  name?: string | null;
  publicDocumentId?: string | null;
}

export interface CallDetailsInput {
  attempt?: number | null;
  reason?: string | null;
}

export interface ComsPrescriptionInput {
  files?: (COMS_REQUESTED_PRESCRIPTION_INPUT | null)[] | null;
}

export enum ARTICLE_LIST_TYPE {
  RECENT_SEARCH = "recentSearch",
  LATEST_ARTICLES = "latestArticles",
  ARTICLE_DATA = "articleData",
}

export type ArticleEntityType = {
  id: string;
  image: string;
  slug: string;
  title: string;
};

export enum RefundTypeForSampleRejected {
  REFUND_TO_BANK = "REFUND_TO_BANK",
  REFUND_TO_PREPAID = "REFUND_TO_PREPAID",
  REFUND_TO_UPI = "REFUND_TO_UPI",
}

export interface CallDetailsInput {
  attempt?: number | null;
  reason?: string | null;
}
export interface COMS_REQUESTED_PRESCRIPTION_INPUT {
  documentId?: string | null;
  format?: string | null;
  name?: string | null;
  publicDocumentId?: string | null;
}
export interface ComsPrescriptionInput {
  files?: (COMS_REQUESTED_PRESCRIPTION_INPUT | null)[] | null;
}
export interface ExternalServiceInput {
  metadata?: AppointmentMetaDataInput | null;
  name?: AppointmentProjectType | null;
}
export interface AppointmentMetaDataInput {
  appointmentProjectType?: AppointmentProjectType | null;
  callDetails?: (CallDetailsInput | null)[] | null;
  comsAppointmentId?: string | null;
  comsPrescription?: ComsPrescriptionInput | null;
  medicines?: (MedicineObjectInput | null)[] | null;
  patientDetails?: PatientMetaDataInput | null;
  provider?: COMS_PROVIDER | null;
  providerConsultationId?: string | null;
  receivedAt?: number | null;
  sympAIChatId?: string | null;
}
export interface BookAppointmentInputV2 {
  appointmentType?: APPOINTMENT_TYPE | null;
  bookingSource?: BOOKINGSOURCE | null;
  externalServiceInput?: ExternalServiceInput | null;
  patientId: string;
}

export interface MedicineObjectInput {
  name?: string | null;
  orderedQuantity?: number | null;
  sku?: string | null;
}
export interface PatientMetaDataInput {
  age?: number | null;
  firstName?: string | null;
  gender?: Gender | null;
  id: string;
}

export interface PatientAskApolloInfoInput {
  chatId: string;
  id?: string | null;
  mobileNumber?: string | null;
  patientId?: string | null;
}

export interface GenerateOtpEmailIdInput {
  email?: string | null;
  partnerId?: string | null;
}

export enum REWARD_METHODS {
  TWID = "TWID",
}

export interface RewardPayment {
  format?: string | null;
  merchant_id?: string | null;
  order_id: string;
  payment_method?: REWARD_METHODS | null;
  payment_method_type: PAYMENT_METHODS_JUSPAY;
  redirect_after_payment?: boolean | null;
  applied_offer_ids?: (string | null)[] | null;
}

export enum REWARD_REDEEM_TYPE {
  AMOUNT = "AMOUNT",
  POINTS = "POINTS",
}

export interface CouponInfo {
  coupon_applied: boolean;
  coupon_code: string;
  coupon_discount: number;
}

export interface CouponOfferDetailsInput {
  code: any;
  offer_id?: any | null;
}

export interface PaymentInstrumentPreferenceCodDetailsInput {
  cod_eligible: boolean;
  cod_ineligibility_reason: (any | null)[];
}

export interface PaymentInstrumentPreferenceInput {
  cod_details?: PaymentInstrumentPreferenceCodDetailsInput | null;
  couponOfferDetails?: CouponOfferDetailsInput | null;
  healthCreditShare?: number | null;
}
export enum FilterDisplayType {
  IMAGE_HEADING = "IMAGE_HEADING",
  MULTIPLE_CHOICE = "MULTIPLE_CHOICE",
  RANGE = "RANGE",
  TITLE = "TITLE",
}
export interface PatientConsultsAndOrdersByMobileInput {
  mobileNumber: string;
  filter?: CONSULTS_RX_SEARCH_FILTER[] | null;
  offset?: number | null;
  limit?: number | null;
}

export enum ButtonTypes {
  BOOK_PHYSICAL_CONSULT = "bookPhysicalConsult",
  BOOK_VIDEO_CONSULT = "bookVideoConsult",
  REQUEST_APPOINTMENT = "requestAppointment",
  REQUEST_HOSPITAL_CONSULT = "requestHospitalConsult",
  REQUEST_VIDEO_CONSULT = "requestVideoConsult",
}

export enum ButtonTitles {
  REQUEST_APPOINTMENT = "Request Appointment",
  BOOK_PHYSICAL_CONSULT = "Book Hospital Visit",
  BOOK_VIDEO_CONSULT = "Book Online Consult",
  REQUEST_HOSPITAL_CONSULT = "Request Hospital Visit",
  REQUEST_VIDEO_CONSULT = "Request Online Consult",
}

export interface DoctorButton {
  button_title: ButtonTitles;
  button_type: ButtonTypes;
  button_subTitle: string;
}

export enum MEAL_TYPE {
  BREAKFAST = "BREAKFAST",
  DINNER = "DINNER",
  LUNCH = "LUNCH",
  NA = "NA",
  SNACKS = "SNACKS",
}

export enum RANGE_TYPE {
  ACCEPTABLE = "ACCEPTABLE",
  BORDERLINE = "BORDERLINE",
  BORDERLINE_HYPER = "BORDERLINE_HYPER",
  BORDERLINE_HYPO = "BORDERLINE_HYPO",
  HYPER = "HYPER",
  HYPO = "HYPO",
  OUT_OF_RANGE = "OUT_OF_RANGE",
}

export enum READING_TYPE {
  MORNING_FASTING = "MORNING_FASTING",
  POST_MEAL = "POST_MEAL",
  PRE_MEAL = "PRE_MEAL",
  RANDOM = "RANDOM",
}

export enum SERVING_SIZE {
  LARGE = "LARGE",
  MEDIUM = "MEDIUM",
  SMALL = "SMALL",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
